module.exports = __webpack_public_path__ + "img/knight.954fe6a6.png";